var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrincess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, "-->\n", /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.7711 214.19H210.244L181.235 195.442H74.8185L45.7711 214.19ZM38.814 207.986L58.3454 180.515V74.946L38.814 47.0973V207.986ZM197.73 74.5072V180.281L217.186 207.91V47.0443L197.73 74.5072ZM197.73 192.537C197.73 194.142 196.429 195.442 194.823 195.442H191.939L209.101 206.533L197.73 190.373V192.537ZM47.0354 206.458L64.0989 195.442H61.2525C59.6486 195.44 58.3454 194.14 58.3454 192.537V190.547L47.0354 206.458ZM159.091 174.213L182.945 189.632H191.916V182.119L175.019 158.121L159.091 174.213ZM83.8196 189.632H172.241L153.663 177.625H102.42L83.8196 189.632ZM64.1595 182.369V189.632H73.1L96.9617 174.221L81.1624 158.439L64.1595 182.369ZM64.1595 172.337L77.8769 153.03L77.7255 102.575L64.1595 83.2303V172.337ZM178.199 102.084L178.343 152.75L191.916 172.019V82.7158L178.199 102.084ZM102.859 83.3362L83.5395 102.855L83.6909 152.75L102.776 171.815H153.3L172.529 152.372L172.385 102.568L152.77 83.1849L102.859 83.3362ZM64.1595 73.1152L81.011 97.1357L97.0904 80.9001L73.1681 65.4437H64.1595V73.1152ZM158.599 80.7639L174.815 96.7953L191.916 72.6537V65.4437H182.514L158.599 80.7639ZM102.579 77.5259L153.111 77.3746L171.741 65.4437H83.8726L102.579 77.5259ZM58.3454 64.8309V62.5385C58.3468 60.9364 59.6494 59.6353 61.2525 59.6334H64.1746L46.831 48.4213L58.3454 64.8309ZM191.576 59.6334H194.823C196.428 59.6334 197.729 60.9352 197.73 62.5385V64.4451L209.093 48.4061L191.576 59.6334ZM74.8866 59.6334H180.803L210.176 40.8103H45.756L74.8866 59.6334ZM223 220H33V35H223V220Z",
    fill: "#4C4B4C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrincess);
export default __webpack_public_path__ + "static/media/Princess.c63e6690aabd4d3b1a148d43ed7338aa.svg";
export { ForwardRef as ReactComponent };